import * as React from "react";
import { Button, styled } from "@mui/material";
import { MethodButton } from "fe-web-components/clinic/clinicActionButton";
import { useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { ManualCaseForm } from "../patients/manualCaseForm";
import { NewCaseChat } from "./newCaseChat";
import { ReactComponent as ChatCaseIcon } from "../../../assets/clinic/chatCaseIcon.svg";
import { ReactComponent as FreeTextCaseIcon } from "../../../assets/clinic/freeTextCaseIcon.svg";

//region [[ Styles ]]

const NewCaseStyled = styled("div")({
  maxWidth: 600,
});

const NewCaseTitle = styled("div")({
  marginBottom: 20,
  "& h3": {
    textAlign: "center",
    margin: 0,
  },
});
const NewCaseButtons = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 10,
});

const IconHolder = styled("div")({
  minWidth: 78,
  height: 78,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#E6E4FF",
  borderRadius: 8,
});

const BackButton = styled(Button)({
  "& .MuiButton-startIcon": {
    marginRight: 0,
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface NewCaseProps {
  clinicId: string;
  onSave: (caseDigitId: string) => void;
  onError: (message: string) => void;
}

enum NewCaseMethods {
  Chat = "chat",
  FreeText = "freeText",
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const NewCase = ({ clinicId, onSave, onError }: NewCaseProps) => {
  const [method, setMethod] = useState<NewCaseMethods>(null);
  const [lastCaseId, setLastCaseId] = useState<string>(null);
  return (
    <NewCaseStyled>
      <NewCaseTitle>
        {!method && <h3>Create a new case</h3>}
        {method && (
          <BackButton
            title={"Back"}
            startIcon={<ArrowBackIosIcon />}
            onClick={() => setMethod(null)}
            variant={"text"}
            size={"small"}
            color={"primary"}
          >
            Back
          </BackButton>
        )}
      </NewCaseTitle>
      {!method && (
        <NewCaseButtons>
          <MethodButton
            onClick={() => setMethod(NewCaseMethods.Chat)}
            label={"Chatbot"}
            icon={
              <IconHolder>
                <ChatCaseIcon style={{ marginLeft: 3 }} />
              </IconHolder>
            }
            subTitle={
              "Go through Kahun's clinical intake (chatbot) to generate a detailed patient summary"
            }
          />
          <MethodButton
            onClick={() => setMethod(NewCaseMethods.FreeText)}
            label={"Free Text"}
            icon={
              <IconHolder>
                <FreeTextCaseIcon style={{ marginLeft: 9, marginBottom: 2 }} />
              </IconHolder>
            }
            subTitle={"Manually create a patient summary using free text"}
          />
        </NewCaseButtons>
      )}
      {method === NewCaseMethods.Chat && (
        <NewCaseChat
          clinicId={clinicId}
          onSave={onSave}
          caseId={lastCaseId}
          onNewCase={setLastCaseId}
        />
      )}
      {method === NewCaseMethods.FreeText && (
        <ManualCaseForm
          clinicId={clinicId}
          onError={onError}
          onSave={onSave}
          showExample={true}
        />
      )}
    </NewCaseStyled>
  );
};
